import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import styles from "./AddToEmailGroup.module.css";
import { useState } from "react";
import { X } from "react-feather";

const AddToEmailGroup = ({
  groupList,
  setSelectedEmailGroup,
  handleAddToGroup,
  selectedProspectForEmailGroup,
  closeAddToEmailGroupSection,
}) => {
  const [selectedGroup, setSelectedGroup] = useState("");

  const handleChange = (event) => {
    const groupId = event.target.value;
    setSelectedGroup(groupId);
    setSelectedEmailGroup(groupId); // Pass selected groupId to parent
  };

  return (
    <div className={styles.AddEmailSec}>
      <div className={styles.AddEmailSecUnder}>
        <div className={styles.AddEmailFieldRow}>
          <div className={`${styles.SelectEmailGroupField} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="select-group-label">
                Select Email Group*
              </InputLabel>
              <Select
                labelId="select-group-label"
                id="select-group"
                value={selectedGroup}
                label="Select Email Group*"
                onChange={handleChange}
              >
                {groupList.map((group) => (
                  <MenuItem key={group.id} value={group.id}>
                    {group.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <Button
            onClick={handleAddToGroup}
            className={styles.SelectEmailGroupAddBU}
          >
            Add
          </Button>          
        </div>
        <p className={styles.AddEmailText}>
          {selectedProspectForEmailGroup.length} Prospect selected.
        </p>
        <button onClick={closeAddToEmailGroupSection} className={styles.SelectEmailGroupCloseBU}><X /></button>
      </div>
    </div>
  );
};

export default AddToEmailGroup;
